import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppSidebarExpander } from '../AppSidebarExpander';
import { AppSidebarNav } from '../AppSidebarNav';
import { useAppShell } from '../AppShellContext';
import { useThemeData } from '@msrceng/theme';
import { Stack } from '@fluentui/react';
/**
 * The sidebar is a vertical navigation menu that is displayed on the left side of the screen.
 */
const AppSidebar = ({ isViewportWidthLarge }) => {
    const { appLinks } = useAppShell();
    const { theme } = useThemeData();
    if (!isViewportWidthLarge)
        return null;
    if (appLinks.length < 1)
        return null;
    return (_jsxs(Stack, Object.assign({ horizontalAlign: 'start', style: { background: theme.palette.neutralLighter } }, { children: [_jsx(Stack, Object.assign({ horizontalAlign: 'center' }, { children: _jsx(AppSidebarNav, {}) })), _jsx("div", { style: { flexGrow: 2 } }), _jsx(AppSidebarExpander, {})] })));
};
// Exports
// -------
export { AppSidebar };
